import moment from 'moment';
import { Instance } from 'mobx-state-tree';
import getFormattedTime from '../../../helpers/getFormattedTime';
import { RouteTemplatesConstraintDtoModelBase } from './RouteTemplatesConstraintDtoModel.base';
import { RouteTemplatesConstraintLocationDtoModelType } from './RouteTemplatesConstraintLocationDtoModel';
import getAppRoot from '../utils/getAppRoot';
import { defaultTimeFormat } from '../../../constants';

/* The TypeScript type of an instance of RouteTemplatesConstraintDtoModel */
export interface RouteTemplatesConstraintDtoModelType extends Instance<typeof RouteTemplatesConstraintDtoModel.Type> { }

/* A graphql query fragment builders for RouteTemplatesConstraintDtoModel */
export { selectFromRouteTemplatesConstraintDto, routeTemplatesConstraintDtoModelPrimitives, RouteTemplatesConstraintDtoModelSelector } from './RouteTemplatesConstraintDtoModel.base';

/**
 * RouteTemplatesConstraintDtoModel
 */
export const RouteTemplatesConstraintDtoModel = RouteTemplatesConstraintDtoModelBase
  .views(self => ({
    get activeStartLocation(): RouteTemplatesConstraintLocationDtoModelType | undefined {
      return self.startLocations?.length ? self.startLocations?.find((l) => l?.active) || self.startLocations?.[0] : undefined;
    },
    get activeEndLocation(): RouteTemplatesConstraintLocationDtoModelType | undefined {
      return self.endLocations?.length ? self.endLocations?.find((l) => l?.active) || self.endLocations?.[0] : undefined;
    },
    get startTimeString(): string | undefined {
      return getFormattedTime(moment(self.startTime, defaultTimeFormat), getAppRoot(self).organization.settings.dateTimeFormat);
    },
    get endTimeString(): string | undefined {
      return getFormattedTime(moment(self.endTime, defaultTimeFormat), getAppRoot(self).organization.settings.dateTimeFormat);
    },
    get shiftTimeString(): string | undefined {
      return this.startTimeString && this.endTimeString ? this.startTimeString + ' – ' + this.endTimeString : undefined;
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
